module.exports = __webpack_public_path__ + "twitter-icon--c3d9d107.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/icons/twitter-icon.png
// module id = 12
// module chunks = 0